module.exports = __webpack_public_path__ + "static/media/styled_components.3745d5de.png";